import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { Question } from 'src/app/core/models/questionnaire.model';
import { QuestionAnswer } from '../question/question.component';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-question-search-list',
  templateUrl: './question-search-list.component.html',
  styleUrls: ['./question-search-list.component.scss'],
})
export class QuestionSearchListComponent implements OnInit {
  @Input('question') question!: Question;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  selectedValues: string[] = [];
  searchText = '';
  filteredOptions: { key: string; value: string }[] = [];

  get maxSelections(): number | null {
    return this.question?.configuration?.maxSelections ?? null;
  }

  get isMaxReached(): boolean {
    return this.maxSelections !== null && this.selectedValues.length >= this.maxSelections;
  }

  ngOnInit(): void {
    const answerValue = this.question?.answer?.value;
    if (answerValue && typeof answerValue === 'string') {
      this.selectedValues = answerValue
        .split(',')
        .map((v) => v.trim())
        .filter((v) => v.length > 0);
    }

    this.filterOptions();
    this.change();
  }

  filterOptions(): void {
    const options = this.question?.configuration?.options || [];
    const search = (typeof this.searchText === 'string' ? this.searchText : '').toLowerCase();

    this.filteredOptions = options.filter(
      (opt: { key: string; value: string }) =>
        !this.selectedValues.includes(opt.value) &&
        opt.key.toLowerCase().includes(search)
    );
  }

  select(event: MatAutocompleteSelectedEvent): void {
    const option = event.option.value as { key: string; value: string };
    if (!this.selectedValues.includes(option.value)) {
      this.selectedValues.push(option.value);
    }
    this.searchText = '';
    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
    }
    this.filterOptions();
    this.change();
  }

  remove(value: string): void {
    const index = this.selectedValues.indexOf(value);
    if (index >= 0) {
      this.selectedValues.splice(index, 1);
    }
    this.filterOptions();
    this.change();
  }

  getOptionLabel(value: string): string {
    const options = this.question?.configuration?.options || [];
    const found = options.find((opt: { key: string; value: string }) => opt.value === value);
    return found ? found.key : value;
  }

  change(): void {
    setTimeout(() => {
      const val = this.checkValid();
      this.question.isValid = val;

      this.changeAnswer.next({
        answer: {
          value: this.selectedValues.join(', '),
          addtional_information: { array: this.selectedValues },
        },
        question: this.question,
      });
    }, 10);
  }

  checkValid(): boolean {
    if (this.question.configuration?.required) {
      return this.selectedValues.length > 0;
    }
    return true;
  }
}
